import { useCallback, useState } from 'react';
import { NotificationCloseType } from 'components/Notification';
import useTracking from 'hooks/useTracking';
import useBrazeInAppMessage from 'libs/common/braze/hooks/useBrazeInAppMessage';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { Screen } from 'constants/tracking/screens';
import { brazeLogInAppMessageButtonClick, brazeLogInAppMessageClick, brazeLogInAppMessageImpression } from 'libs/common/braze/utils/event-loggers';
import NotificationInAppMessage from './NotificationInAppMessage';
import ModalInAppMessage from './ModalInAppMessage';
import { jsx as _jsx } from "react/jsx-runtime";

const InAppMessage = () => {
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = useState(true);
  const {
    track
  } = useTracking();
  const {
    notificationInAppMessage,
    modalInAppMessage
  } = useBrazeInAppMessage();
  const anyInAppMessage = notificationInAppMessage !== null && notificationInAppMessage !== void 0 ? notificationInAppMessage : modalInAppMessage;

  const trackDismissal = inAppMessage => {
    if (!inAppMessage) return;
    const targetDetails = JSON.stringify({
      campaign_name: inAppMessage.campaignName,
      campaign_message_name: inAppMessage.campaignMessageName,
      canvas_name: inAppMessage.canvasName,
      canvas_variant_name: inAppMessage.canvasVariantName
    });
    track(clickEvent({
      target: ClickableElement.CrmInAppMessageDismiss,
      screen: Screen.CrmInAppMessage,
      targetDetails
    }));
  };

  const closeModal = () => {
    setIsModalOpen(false);
    trackDismissal(modalInAppMessage);
  };

  const handlePrimaryButtonClick = () => {
    if (!modalInAppMessage) return;
    if (!modalInAppMessage.primaryButtonUrl) closeModal();
    brazeLogInAppMessageButtonClick(modalInAppMessage, 0);
  };

  const handleSecondaryButtonClick = () => {
    if (!modalInAppMessage) return;
    if (!modalInAppMessage.secondaryButtonUrl) closeModal();
    brazeLogInAppMessageButtonClick(modalInAppMessage, 1);
  };

  const handleModalLinkClick = url => {
    if (!modalInAppMessage) return;
    const targetDetails = JSON.stringify({
      campaign_name: modalInAppMessage.campaignName,
      campaign_message_name: modalInAppMessage.campaignMessageName,
      canvas_name: modalInAppMessage.canvasName,
      canvas_variant_name: modalInAppMessage.canvasVariantName,
      url
    });
    track(clickEvent({
      target: ClickableElement.CrmMessageLink,
      screen: Screen.CrmInAppMessage,
      targetDetails
    }));
  };

  const handleNotificationClose = closeType => {
    if (notificationInAppMessage !== null && notificationInAppMessage !== void 0 && notificationInAppMessage.url || closeType === NotificationCloseType.Auto) {
      trackDismissal(notificationInAppMessage);
      return;
    }

    if (notificationInAppMessage) {
      brazeLogInAppMessageClick(notificationInAppMessage);
    }
  };

  const handleNotificationLinkClick = () => {
    if (!(notificationInAppMessage !== null && notificationInAppMessage !== void 0 && notificationInAppMessage.url)) return;
    brazeLogInAppMessageClick(notificationInAppMessage);
  };

  const handleInAppMessageEnter = useCallback(() => {
    if (!anyInAppMessage) return;
    brazeLogInAppMessageImpression(anyInAppMessage);
  }, [anyInAppMessage]);

  if (notificationInAppMessage) {
    return /*#__PURE__*/_jsx(NotificationInAppMessage, {
      onEnter: handleInAppMessageEnter,
      inAppMessage: notificationInAppMessage,
      onClose: handleNotificationClose,
      onLinkClick: handleNotificationLinkClick
    });
  }

  if (modalInAppMessage) {
    return /*#__PURE__*/_jsx(ModalInAppMessage, {
      isOpen: isModalOpen,
      inAppMessage: modalInAppMessage,
      onClose: closeModal,
      onLinkClick: handleModalLinkClick,
      onEnter: handleInAppMessageEnter,
      onPrimaryButtonClick: handlePrimaryButtonClick,
      onSecondaryButtonClick: handleSecondaryButtonClick
    });
  }

  return null;
};

export default InAppMessage;